import { Button } from '@factorialco/deprecated-design-system'
import {
  AtsDeleteSmartActionCandidateEmailDocument,
  AtsGetJobPostingSettingsSmartActionsDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  onClose: () => void
  id: string
}

export const DeleteSmartAction = ({ onClose, id }: Props) => {
  const [deleteSmartAction] = useMutation(AtsDeleteSmartActionCandidateEmailDocument, {
    extractorFn: (data) => data.atsMutations.deleteAtsCandidateEmailAction,
  })
  const onDelete = async () => {
    const result = await deleteSmartAction({
      variables: {
        id,
      },
      refetchQueries: [AtsGetJobPostingSettingsSmartActionsDocument],
    })

    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    }

    return handled
  }

  return (
    <Modal
      title={i18n.t('ats.job_posting_settings.smart_actions.actions.delete_title')}
      description={i18n.t('ats.job_posting_settings.smart_actions.actions.delete_description')}
      illustration="delete"
      onClose={onClose}
      onSubmit={() => onDelete()}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" submit>
            {i18n.t('ats.job_posting_settings.smart_actions.actions.delete_submit')}
          </Button>
        </>
      }
    />
  )
}
